<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onCancel()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "catalog_basket_button_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper">
    <div class="form form-horizontal">
        <div class="form-group mb-20" [class.has-error]="saveDisablePredicate">
            <label class="col-xs-12">
                {{ "control_text" | translate }}
            </label>
            <div class="col-xs-12">
                <input class="form-control" [formControl]="label" />
                <span class="help-block small" *ngIf="saveDisablePredicate">
                    {{ "control_errors_required" | translate }}
                </span>
            </div>
        </div>

        <div class="form-row mb-20">
            <div class="form-group">
                <label class="col-xs-12">
                    {{ "control_style" | translate }}
                </label>
                <div class="col-xs-6">
                    <select class="form-control" [formControl]="styleType">
                        <option [ngValue]="EButtonStyleType.primary">
                            {{ "control_appearance_primary" | translate }}
                        </option>
                        <option [ngValue]="EButtonStyleType.secondary">
                            {{ "control_appearance_secondary" | translate }}
                        </option>
                        <option [ngValue]="EButtonStyleType.custom">
                            {{ "control_appearance_custom" | translate }}
                        </option>
                    </select>
                </div>
                <div class="col-xs-6">
                    <div class="btn-group d-flex">
                        <sp-radio-group
                            [selected]="size.value"
                            [type]="ERadioGroupType.size"
                            (changeSelectedEvent)="setSize($event)"
                        ></sp-radio-group>
                    </div>
                </div>
            </div>
        </div>
        @if (styleType.value === EButtonStyleType.custom) {
            <div class="form-row mb-20">
                <sp-custom-button
                    showHoverSettings
                    [parentBase]="buttonBase.value"
                    [parentHover]="buttonHover.value"
                    [colorsPreset]="selectedThemeColors()"
                    [buttonMode]="ButtonMode.light"
                    (valueChangeEvent)="customButtonChangeHandler($event)"
                ></sp-custom-button>
            </div>
        }
        <div class="form-row">
            <sp-button-icon [buttonIcon]="buttonIcon.value" (valueChangeEvent)="buttonIconChangeHandler($event)">
            </sp-button-icon>
        </div>
    </div>
</div>

<web-settings-footer
    [isSaveDisabled]="saveDisablePredicate"
    (saveEvent)="onSave()"
    (cancelEvent)="onReset()"
></web-settings-footer>
